<div class="boxes-wrapper" [style.grid-area]="gridArea()">
    @for (box of boxesValues(); track box) {
        <app-box [numericValue]="box.value" [titleValue]="box.title ?? ''" [formatType]="box.formatType"></app-box>
    }
</div>
